import {
  ADD_CONTEXT,
  LOAD_BOOK_CONTEXT,
} from './../../action-types/bookproperties';

export const STATE_KEY = 'context';

export const context = (state = '', action) => {
  switch (action.type) {
    case ADD_CONTEXT: {
      return action.context;
    }

    case LOAD_BOOK_CONTEXT: {
      return action.context;
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/redux/reducers/bookproperties/context.js